import { Injectable } from '@angular/core';
import { Apollo, gql, Query } from 'apollo-angular';
import { IdeaFileItem } from '../idea/get-idea-files.graphql';
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };

// Escrita à mão (o codegen aponta para um host fora do ar). Substitui a
// GetIdeaKaizen gerada, que espalhava `...Idea` sem defini-lo e a API recusava.

export type IdeaKaizenDetail = {
  id: string;
  code?: string | null;
  title: string;
  description?: string | null;
  problem?: string | null;
  solution?: string | null;
  status: string;
  motive?: string | null;
  likes: number;
  createdAt?: any | null;
  phone?: string | null;
  phoneExtensionLine?: string | null;
  productiveDescription?: string | null;
  unity?: { id: string; name: string } | null;
  authors?: Array<{ id: string; name: string; re: string }> | null;
  expectations?: Array<{
    id: string;
    expectation: string;
    expectationDescription: string;
    challengeLanguage?: string | null;
  }> | null;
  comments?: Array<{ id: string; comment: string; createdAt?: any | null; user?: { name: string } | null }> | null;
  challenge?: { id: string; name: string } | null;
  ideafiles?: Array<IdeaFileItem> | null;
  canManageFiles: boolean;
};

export type GetIdeaKaizenDetailQuery = { getIdeaKaizen: IdeaKaizenDetail };
export type GetIdeaKaizenDetailQueryVariables = Exact<{
  id: string;
}>;

export const GetIdeaKaizenDetailDocument = gql`
    query GetIdeaKaizenDetail($id: String!) {
  getIdeaKaizen(id: $id) {
    id
    code
    title
    description
    problem
    solution
    status
    motive
    likes
    createdAt
    phone
    phoneExtensionLine
    productiveDescription
    unity {
      id
      name
    }
    authors {
      id
      name
      re
    }
    expectations {
      id
      expectation
      expectationDescription
      challengeLanguage
    }
    comments {
      id
      comment
      createdAt
      user {
        name
      }
    }
    challenge {
      id
      name
    }
    ideafiles {
      id
      fileName
      originalName
      createdAt
    }
    canManageFiles
  }
}
    `;

@Injectable({
  providedIn: 'root'
})
export class GetIdeaKaizenDetailGQL extends Query<GetIdeaKaizenDetailQuery, GetIdeaKaizenDetailQueryVariables> {
  document = GetIdeaKaizenDetailDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
